import { render, staticRenderFns } from "./ProblemSolved.vue?vue&type=template&id=43fdb01b&scoped=true&"
import script from "./ProblemSolved.vue?vue&type=script&lang=js&"
export * from "./ProblemSolved.vue?vue&type=script&lang=js&"
import style0 from "./ProblemSolved.vue?vue&type=style&index=0&id=43fdb01b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fdb01b",
  null
  
)

export default component.exports